var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.settingsLink(_vm.nodeData))?_c('div',{staticClass:"hierarchy-location-item-icon ml-2 mr-2",on:{"click":_vm.HamburgerClick}},[_c('font-awesome-icon',{staticClass:"color-silver",attrs:{"title":_vm.$t('Več možnosti'),"icon":"bars"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }